<template>
  <div style="display: flex; flex-direction: column; height: 100%">
    <div style="display: flex; flex-direction: column">
      <v-text-field
        v-model="userEditObj.name"
        label="Name"></v-text-field>
      <v-text-field
        v-model="userEditObj.description"
        label="Description"></v-text-field>
      <v-select
        label="Available button slots"
        v-model="userEditObj.available_slots"
        :items="[5, 10, 15, 25, 50, 75, 100]"></v-select>
      <SelectIcon
        v-model="userEditObj.icon"
        label="Icon"></SelectIcon>
      <!-- hex color picker using vuetify picker -->

      <v-color-picker
        v-model="userEditObj.color"
        label="Color"
        hide-details></v-color-picker>
    </div>
  </div>
</template>
<script setup>
import SelectIcon from '../Shared/SelectIcon.vue';

import { ref } from 'vue';
import { $http } from '../../stores/http.js';
const props = defineProps(['userEditObj']);
</script>
